import React, { useState } from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import { useParams } from 'react-router-dom';
import {
  ShieldCheckIcon,
  AccessibilityIcon,
  VisaIcon,
  ShieldIcon,
  ChevronDownIcon,
} from '../icons';
import css from './GutZuWissen.module.css';

const CANCELLATION_ROWS = [
  { labelId: 'GutZuWissen.cancellationRow30', valueId: 'GutZuWissen.cancellationFree', highlight: true },
  { labelId: 'GutZuWissen.cancellationRow29', valueId: 'GutZuWissen.cancellation20' },
  { labelId: 'GutZuWissen.cancellationRow14', valueId: 'GutZuWissen.cancellation50' },
  { labelId: 'GutZuWissen.cancellationRow7', valueId: 'GutZuWissen.cancellation80' },
];

const AccordionItem = ({ icon: Icon, titleId, isOpen, onToggle, children }) => (
  <div className={css.item}>
    <button type="button" className={css.trigger} onClick={onToggle} aria-expanded={isOpen}>
      <span className={css.iconWrap}>
        <Icon className={css.icon} size={20} />
      </span>
      <span className={css.itemTitle}>
        <FormattedMessage id={titleId} />
      </span>
      <ChevronDownIcon className={isOpen ? css.chevronOpen : css.chevron} size={20} />
    </button>
    {isOpen && <div className={css.panel}>{children}</div>}
  </div>
);

const GutZuWissen = ({ embedded = false }) => {
  const { lang } = useParams();
  const [openIndex, setOpenIndex] = useState(null);

  const foreignMinistryLink =
    lang === 'en'
      ? 'https://www.auswaertiges-amt.de/en'
      : 'https://www.auswaertiges-amt.de/de/ReiseUndSicherheit/reise-und-sicherheitshinweise';

  const toggle = index => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const contactLink = (
    <a
      href={`https://www.socialbnb.org/${lang}/contact`}
      target="_blank"
      rel="noopener noreferrer"
      className={css.link}
    >
      {lang === 'de' ? 'bei uns.' : 'contact us'}
    </a>
  );

  const foreignMinistryAnchor = (
    <a
      href={foreignMinistryLink}
      target="_blank"
      rel="noopener noreferrer"
      className={css.link}
    >
      {lang === 'de' ? 'Auswärtigen Amt' : 'Federal Foreign Office'}
    </a>
  );

  const agbLink = (
    <a
      href="https://www.socialbnb.org/en/p/agb"
      target="_blank"
      rel="noopener noreferrer"
      className={css.link}
    >
      <FormattedMessage id="experienceListing.common.cancellationText6.link" />
    </a>
  );

  return (
    <section
      className={embedded ? css.embeddedSection : css.section}
      id="absicherung"
      data-elbaction="visible:vis gutZuWissen"
    >
      <h2 className={css.title}>
        <FormattedMessage id="GutZuWissen.title" />
      </h2>

      <div className={css.accordion}>
        <AccordionItem
          icon={ShieldCheckIcon}
          titleId="GutZuWissen.cancellationTitle"
          isOpen={openIndex === 0}
          onToggle={() => toggle(0)}
        >
          <div className={css.cancellationGrid}>
            {CANCELLATION_ROWS.map(row => (
              <div key={row.labelId} className={css.cancellationRow}>
                <span>
                  <FormattedMessage id={row.labelId} />
                </span>
                <strong className={row.highlight ? css.highlight : undefined}>
                  <FormattedMessage id={row.valueId} />
                </strong>
              </div>
            ))}
          </div>
          <p className={css.legalNote}>
            <FormattedMessage id="GutZuWissen.cancellationLegal" />
          </p>
          <p className={css.agbNote}>
            <FormattedMessage id="experienceListing.common.cancellationText6" /> {agbLink}
          </p>
        </AccordionItem>

        <AccordionItem
          icon={AccessibilityIcon}
          titleId="listingPage.generalInfo.limitedMobility"
          isOpen={openIndex === 1}
          onToggle={() => toggle(1)}
        >
          <p className={css.bodyText}>
            <FormattedMessage
              id="listingPage.generalInfo.accessibilityNotice"
              values={{ contactLink }}
            />
          </p>
        </AccordionItem>

        <AccordionItem
          icon={VisaIcon}
          titleId="listingPage.generalInfo.visaRequirements"
          isOpen={openIndex === 2}
          onToggle={() => toggle(2)}
        >
          <p className={css.bodyText}>
            <FormattedMessage
              id="listingPage.generalInfo.visaRequirementsNotice"
              values={{ foreignMinistryLink: foreignMinistryAnchor, contactLink }}
            />
          </p>
        </AccordionItem>

        <AccordionItem
          icon={ShieldIcon}
          titleId="GutZuWissen.insuranceTitle"
          isOpen={openIndex === 3}
          onToggle={() => toggle(3)}
        >
          <p className={css.bodyText}>
            <FormattedMessage id="listingPage.generalInfo.travelInsuranceRecommendation" />
          </p>
        </AccordionItem>
      </div>
    </section>
  );
};

export default GutZuWissen;
